import {
  AttributeHeader,
  AttributeValue,
  Card,
  DATE_FORMATTER_STR_WITH_TIME,
  formatDate,
  TeamLogo,
} from "best-common-react";
import React from "react";
import styled from "styled-components";
import { PurchaseOpportunityDTO } from "../../types/PurchaseOpportunity";

type OppContainerProps = {
  hasHover: boolean;
};

const OppContainer = styled.div<OppContainerProps>`
  @media (max-width: 767px) {
    width: 100%;
  }

  @media (min-width: 768px) {
    min-width: 275px;
    width: 275px;
  }

  &:hover {
    ${({ hasHover }) => (hasHover ? "cursor: pointer" : "")};
  }
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Details = styled.div`
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
`;

type PurchaseOpportunityCardProps = {
  opp: PurchaseOpportunityDTO;
  onClick?: (id: number | string) => void;
  className?: string;
};

const PurchaseOpportunityCard: React.FC<PurchaseOpportunityCardProps> = ({ opp, onClick, className }) => {
  return (
    <OppContainer hasHover={!!onClick} className={className}>
      <Card key={opp.purchaseOpportunityId}>
        <Card.Body>
          <ContentContainer
            onClick={() => {
              if (!!onClick) {
                onClick(opp.purchaseOpportunityId);
              }
            }}
          >
            <div>
              <TeamLogo teamId={opp.teamId} size="2.5rem" />
            </div>
            <Details>
              <AttributeHeader>Year</AttributeHeader>
              <AttributeValue>{opp.year}</AttributeValue>
              <AttributeHeader>Type</AttributeHeader>
              <AttributeValue>{opp.seriesType.description}</AttributeValue>
              <AttributeHeader>Number of Winners</AttributeHeader>
              <AttributeValue>{opp.numOfWinners}</AttributeValue>
              <AttributeHeader>Games Numbers</AttributeHeader>
              <AttributeValue>{opp.gameNumbers.map((num) => `Home Game #${num}`).join(", ")}</AttributeValue>
              <AttributeHeader>Cutoff Date</AttributeHeader>
              <AttributeValue>
                {formatDate(new Date(opp.cutoffDate as string), DATE_FORMATTER_STR_WITH_TIME)}
              </AttributeValue>
              <AttributeHeader>Cost for a Pair of Tickets</AttributeHeader>
              <AttributeValue>{opp.costDescription}</AttributeValue>
            </Details>
          </ContentContainer>
        </Card.Body>
      </Card>
    </OppContainer>
  );
};

export default PurchaseOpportunityCard;
